import PaymentIcon from '@mui/icons-material/Payment';
import PixIcon from '@mui/icons-material/PixOutlined';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import { PaymentMethod } from '@/data/catalog/offer/interfaces';

export const paymentMethodLabel = {
  [PaymentMethod.Pix]: 'Pix',
  [PaymentMethod.BankSlip]: 'Boleto',
  [PaymentMethod.Card]: 'Cartão de crédito',
};

export const paymentMethodIcon = {
  [PaymentMethod.Pix]: <PixIcon />,
  [PaymentMethod.BankSlip]: <ViewWeekIcon />,
  [PaymentMethod.Card]: <PaymentIcon />,
};

export const paymentMethods = [
  {
    id: PaymentMethod.Pix,
    label: paymentMethodLabel[PaymentMethod.Pix],
    icon: paymentMethodIcon[PaymentMethod.Pix],
  },
  {
    id: PaymentMethod.BankSlip,
    label: paymentMethodLabel[PaymentMethod.BankSlip],
    icon: paymentMethodIcon[PaymentMethod.BankSlip],
  },
  {
    id: PaymentMethod.Card,
    label: paymentMethodLabel[PaymentMethod.Card],
    icon: paymentMethodIcon[PaymentMethod.Card],
  },
];
